module.exports = __webpack_public_path__ + "static/Background-gov-2.62f18913.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Background-gov-2.jpg
// module id = 467
// module chunks = 53566712009029